import classNames from 'classnames';
import React, { forwardRef } from 'react';

import { InputField } from '../input-field';
import useInputDateService from './input-date.service';
import { InputDateProps } from './input-date.types';

export const InputDate: React.FC<InputDateProps> = forwardRef<
  HTMLInputElement,
  InputDateProps
>(
  (
    {
      id,
      labelKey,
      className,
      LeftIcon,
      size = 'medium',
      helperTextKey,
      helperTextValue,
      ...rest
    },
    ref
  ) => {
    const cssClasses = classNames('input-date', className);

    const { inputRef, handleDateInputClick } = useInputDateService();
    return (
      <div className="input-date" onClick={handleDateInputClick}>
        <input
          ref={inputRef}
          type="date"
          id={id}
          className="hidden-date-input"
          {...rest}
        />
        <InputField
          ref={ref}
          id={id}
          type="text"
          size={size}
          labelKey={labelKey}
          LeftIcon={LeftIcon}
          className={cssClasses}
          helperTextKey={helperTextKey}
          helperTextValue={helperTextValue}
          {...rest}
        />
        <span className="icon-overlay" />
      </div>
    );
  }
);

InputDate.displayName = 'InputDate';
